<script setup lang="ts">
/**
 * UnknownSection —— Section.type 未注册时的 fallback 组件（F03，PRD §User Stories §19）。
 *
 * `console.warn` 包含 type 字符串，便于开发期定位 Registry 漏注册；
 * UI 走 Copy Catalog `fallback.section.unknownType` 显式向用户提示
 * "该模块暂不支持"（Debug-First：不静默隐藏，不静默渲染空）。
 */
import { onMounted } from 'vue';

import type { PublicSectionView } from '@/api/types';
import { copy } from '@/i18n/zh-CN';

const props = defineProps<{ section: PublicSectionView; id?: string }>();

onMounted(() => {
  // eslint-disable-next-line no-console
  console.warn(`[UnknownSection] unsupported section type: "${props.section.type}"`);
});
</script>

<template>
  <section :id="props.id" :class="$style.placeholder" data-section-type="__unknown__">
    <h2 :class="$style.title">{{ copy.fallback.section.title }}</h2>
    <p :class="$style.hint">{{ copy.fallback.section.unknownType }}</p>
    <p :class="$style.meta">{{ copy.fallback.section.typeLabel }}: <code>{{ section.type }}</code></p>
  </section>
</template>

<style module>
.placeholder {
  background: var(--color-bg-secondary);
  border: 1px dashed var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--space-3);
}

.title {
  color: var(--color-brand-primary);
  font-size: var(--font-size-md);
  margin-bottom: var(--space-1);
}

.hint {
  color: var(--color-text-secondary);
  font-size: var(--font-size-sm);
  margin-bottom: var(--space-1);
}

.meta {
  color: var(--color-text-muted);
  font-size: var(--font-size-sm);
}

.meta code {
  background: var(--color-bg-primary);
  padding: 0 var(--space-1);
  border-radius: var(--radius-sm);
}
</style>
